import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import routes from "../modules/routes";
import ReactNotification from 'react-notifications-component';
import './App.scss';

const App = () => {
  return (
    <Router>
      <ReactNotification />
      <div>
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              component={() => {
                return (
                  <route.layout activeRoute={route.name}>
                    <route.component/>
                  </route.layout>
                );}
              }
            />
          );
        })}
      </div>
    </Router>
  );
}

export default App;
